/* ============================================================
   Business Outcomes carousel — Swiper 11 (bundled per page)
   ------------------------------------------------------------
   Same Swiper import style as case-studies-carousel.js, but the
   next card peeks in from the right (slidesPerView: 1.13).

   There is ONE shared prev/next nav ([data-bo-prev]/[data-bo-next])
   living outside the slides, pinned via --bo-nav-right. Its position is
   a layout constant (peek width + card padding) and is only recomputed
   on resize, so the nav never drifts while you slide.

   `rewind` rather than `loop`: with only two real slides, loop mode has
   too few clones for a peeking layout and the "next" step can stall.
   No `slidesOffsetAfter` — it would let the last card sit flush-left but
   leaves an empty gutter after it at the end of the carousel.
   ============================================================ */
import Swiper from "swiper";
import { Navigation, Mousewheel, Keyboard } from "swiper/modules";

/* Card padding — keep in sync with .bo-card in business-outcomes.css */
var CARD_PADDING = 40;
var CARD_PADDING_SM = 24;

export function initBusinessOutcomes() {
  var el = document.querySelector(".business-outcomes-swiper");
  if (!el) return;

  var slider =
    el.closest(".business-outcomes-swiper-wrapper") || el.parentElement;

  var swiper = new Swiper(el, {
    modules: [Navigation, Mousewheel, Keyboard],
    slidesPerView: 1.13,
    spaceBetween: 16,
    loop: true,
    speed: 800,
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
      releaseOnEdges: true,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    breakpoints: {
      767: { spaceBetween: 20 },
    },
  });

  /* Peek width: how much of the container the left-hand card leaves over. */
  function peekWidth() {
    var slide = el.querySelector(".swiper-slide");
    if (!slide) return 0;
    var overhang = el.clientWidth - slide.offsetWidth;
    return overhang > 0 ? overhang : 0;
  }

  function positionNav() {
    if (!slider) return;
    var pad = window.innerWidth <= 767 ? CARD_PADDING_SM : CARD_PADDING;
    slider.style.setProperty("--bo-nav-right", peekWidth() + pad + "px");
  }

  positionNav();
  window.addEventListener("resize", positionNav);

  document.querySelectorAll("[data-bo-prev]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      swiper.slidePrev();
    });
  });
  document.querySelectorAll("[data-bo-next]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      swiper.slideNext();
    });
  });
}
